/* tslint:disable */
/* eslint-disable */
/**
 * ampm-world
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AboutUsPageResource
 */
export interface AboutUsPageResource {
    /**
     * 
     * @type {AboutUsPageResourceHeroBlock}
     * @memberof AboutUsPageResource
     */
    hero_block: AboutUsPageResourceHeroBlock;
    /**
     * 
     * @type {AboutUsPageResourceAboutCompanyBlock}
     * @memberof AboutUsPageResource
     */
    about_company_block: AboutUsPageResourceAboutCompanyBlock;
    /**
     * 
     * @type {Array<AboutUsPageSectionResource>}
     * @memberof AboutUsPageResource
     */
    sections: Array<AboutUsPageSectionResource>;
}
/**
 * 
 * @export
 * @interface AboutUsPageResourceAboutCompanyBlock
 */
export interface AboutUsPageResourceAboutCompanyBlock {
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageResourceAboutCompanyBlock
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageResourceAboutCompanyBlock
     */
    description: string;
}
/**
 * 
 * @export
 * @interface AboutUsPageResourceHeroBlock
 */
export interface AboutUsPageResourceHeroBlock {
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageResourceHeroBlock
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageResourceHeroBlock
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageResourceHeroBlock
     */
    background: string;
}
/**
 * 
 * @export
 * @interface AboutUsPageSectionResource
 */
export interface AboutUsPageSectionResource {
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageSectionResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageSectionResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AboutUsPageSectionResource
     */
    background: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AboutUsPageSectionResource
     */
    companies: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminHomePageBannerResource
 */
export interface AdminHomePageBannerResource {
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBannerResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBannerResource
     */
    bg: string;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBannerResource
     */
    description: string;
    /**
     * 
     * @type {AdminHomePageBannerResourceButton}
     * @memberof AdminHomePageBannerResource
     */
    button: AdminHomePageBannerResourceButton;
}
/**
 * 
 * @export
 * @interface AdminHomePageBannerResourceButton
 */
export interface AdminHomePageBannerResourceButton {
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBannerResourceButton
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBannerResourceButton
     */
    link: string | null;
}
/**
 * 
 * @export
 * @interface AdminHomePageBlockResource
 */
export interface AdminHomePageBlockResource {
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBlockResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBlockResource
     */
    bg: string;
    /**
     * 
     * @type {AdminHomePageBlockResourceButton}
     * @memberof AdminHomePageBlockResource
     */
    button: AdminHomePageBlockResourceButton;
}
/**
 * 
 * @export
 * @interface AdminHomePageBlockResourceButton
 */
export interface AdminHomePageBlockResourceButton {
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBlockResourceButton
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageBlockResourceButton
     */
    link: string;
}
/**
 * 
 * @export
 * @interface AdminHomePageSliderResource
 */
export interface AdminHomePageSliderResource {
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageSliderResource
     */
    type: AdminHomePageSliderResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageSliderResource
     */
    title: string;
    /**
     * 
     * @type {AdminHomePageSliderResourceBg}
     * @memberof AdminHomePageSliderResource
     */
    bg: AdminHomePageSliderResourceBg;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageSliderResource
     */
    title_color: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageSliderResource
     */
    description_color: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageSliderResource
     */
    description: string | null;
    /**
     * 
     * @type {AdminHomePageBannerResourceButton}
     * @memberof AdminHomePageSliderResource
     */
    button: AdminHomePageBannerResourceButton;
}

/**
    * @export
    * @enum {string}
    */
export enum AdminHomePageSliderResourceTypeEnum {
    Image = 'image',
    Video = 'video'
}

/**
 * 
 * @export
 * @interface AdminHomePageSliderResourceBg
 */
export interface AdminHomePageSliderResourceBg {
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageSliderResourceBg
     */
    desk: string;
    /**
     * 
     * @type {string}
     * @memberof AdminHomePageSliderResourceBg
     */
    mobile: string;
}
/**
 * 
 * @export
 * @interface Article
 */
export interface Article {
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    preview_image: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Article
     */
    slider: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    card_image: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    date_publication: string;
}
/**
 * 
 * @export
 * @interface ArticleListResource
 */
export interface ArticleListResource {
    /**
     * 
     * @type {number}
     * @memberof ArticleListResource
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ArticleListResource
     */
    count: number;
    /**
     * 
     * @type {Array<ArticleListResourceArticles>}
     * @memberof ArticleListResource
     */
    articles: Array<ArticleListResourceArticles>;
}
/**
 * 
 * @export
 * @interface ArticleListResourceArticles
 */
export interface ArticleListResourceArticles {
    /**
     * 
     * @type {number}
     * @memberof ArticleListResourceArticles
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResourceArticles
     */
    preview_image: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResourceArticles
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResourceArticles
     */
    date_publication: string;
}
/**
 * 
 * @export
 * @interface ArticleYearsResource
 */
export interface ArticleYearsResource {
    /**
     * 
     * @type {Array<number>}
     * @memberof ArticleYearsResource
     */
    years?: Array<number>;
}
/**
 * 
 * @export
 * @interface Award
 */
export interface Award {
    /**
     * 
     * @type {string}
     * @memberof Award
     */
    preview_image: string;
    /**
     * 
     * @type {string}
     * @memberof Award
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof Award
     */
    count: number | null;
}
/**
 * 
 * @export
 * @interface AwardListResource
 */
export interface AwardListResource {
    /**
     * 
     * @type {string}
     * @memberof AwardListResource
     */
    title: string;
    /**
     * 
     * @type {Array<Award>}
     * @memberof AwardListResource
     */
    awards: Array<Award>;
}
/**
 * 
 * @export
 * @interface BannerDetailResource
 */
export interface BannerDetailResource {
    /**
     * 
     * @type {BannerDetailResourceBanner}
     * @memberof BannerDetailResource
     */
    banner: BannerDetailResourceBanner;
}
/**
 * 
 * @export
 * @interface BannerDetailResourceBanner
 */
export interface BannerDetailResourceBanner {
    /**
     * 
     * @type {BannerEnum}
     * @memberof BannerDetailResourceBanner
     */
    type: BannerEnum;
    /**
     * 
     * @type {string}
     * @memberof BannerDetailResourceBanner
     */
    src: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BannerEnum {
    Video = 'video',
    Image = 'image'
}

/**
 * 
 * @export
 * @interface BigBlock
 */
export interface BigBlock {
    /**
     * 
     * @type {ConstructorEnum}
     * @memberof BigBlock
     */
    type: ConstructorEnum;
    /**
     * 
     * @type {BigBlockItem}
     * @memberof BigBlock
     */
    item: BigBlockItem;
}
/**
 * 
 * @export
 * @interface BigBlockItem
 */
export interface BigBlockItem {
    /**
     * 
     * @type {string}
     * @memberof BigBlockItem
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof BigBlockItem
     */
    reverse: boolean;
    /**
     * 
     * @type {string}
     * @memberof BigBlockItem
     */
    big_image: string;
    /**
     * 
     * @type {string}
     * @memberof BigBlockItem
     */
    small_image: string;
}
/**
 * 
 * @export
 * @interface BrandFilterResource
 */
export interface BrandFilterResource {
    /**
     * 
     * @type {number}
     * @memberof BrandFilterResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BrandFilterResource
     */
    guid: string;
    /**
     * 
     * @type {string}
     * @memberof BrandFilterResource
     */
    title: string;
}
/**
 * 
 * @export
 * @interface CategoryFilterResource
 */
export interface CategoryFilterResource {
    /**
     * 
     * @type {number}
     * @memberof CategoryFilterResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryFilterResource
     */
    guid: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryFilterResource
     */
    title: string;
}
/**
 * 
 * @export
 * @interface Collection
 */
export interface Collection {
    /**
     * 
     * @type {number}
     * @memberof Collection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof Collection
     */
    image: string;
    /**
     * 
     * @type {Array<CollectionCategories>}
     * @memberof Collection
     */
    categories: Array<CollectionCategories>;
}
/**
 * 
 * @export
 * @interface CollectionCategories
 */
export interface CollectionCategories {
    /**
     * 
     * @type {number}
     * @memberof CollectionCategories
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionCategories
     */
    title: string;
}
/**
 * 
 * @export
 * @interface CollectionFilterResource
 */
export interface CollectionFilterResource {
    /**
     * 
     * @type {number}
     * @memberof CollectionFilterResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionFilterResource
     */
    guid: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionFilterResource
     */
    title: string;
}
/**
 * 
 * @export
 * @interface CollectionListResource
 */
export interface CollectionListResource {
    /**
     * 
     * @type {Array<CollectionListResourceCollections>}
     * @memberof CollectionListResource
     */
    collections: Array<CollectionListResourceCollections>;
}
/**
 * 
 * @export
 * @interface CollectionListResourceCollections
 */
export interface CollectionListResourceCollections {
    /**
     * 
     * @type {number}
     * @memberof CollectionListResourceCollections
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionListResourceCollections
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionListResourceCollections
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionListResourceCollections
     */
    description: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionListResourceCollections
     */
    product_count: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionListResourceCollections
     */
    preview_image: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionListResourceCollections
     */
    image: string;
    /**
     * 
     * @type {boolean}
     * @memberof CollectionListResourceCollections
     */
    show_in_header: boolean;
}
/**
 * 
 * @export
 * @interface CollectionPageResource
 */
export interface CollectionPageResource {
    /**
     * 
     * @type {string}
     * @memberof CollectionPageResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionPageResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionPageResource
     */
    video: string;
}
/**
 * Color filter resource
 * @export
 * @interface ColorFilterResource
 */
export interface ColorFilterResource {
    /**
     * Title
     * @type {string}
     * @memberof ColorFilterResource
     */
    title: string;
    /**
     * Image
     * @type {string}
     * @memberof ColorFilterResource
     */
    image: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ConstructorEnum {
    Youtube = 'youtube',
    Small = 'small',
    SmallVideo = 'smallVideo',
    Big = 'big',
    Image = 'image'
}

/**
 * 
 * @export
 * @interface ContactPageResource
 */
export interface ContactPageResource {
    /**
     * 
     * @type {Array<ContactPageResourceHotline>}
     * @memberof ContactPageResource
     */
    hotline: Array<ContactPageResourceHotline>;
    /**
     * 
     * @type {Array<ContactPageResourceBrandCenter>}
     * @memberof ContactPageResource
     */
    brand_center: Array<ContactPageResourceBrandCenter>;
}
/**
 * 
 * @export
 * @interface ContactPageResourceBrandCenter
 */
export interface ContactPageResourceBrandCenter {
    /**
     * 
     * @type {string}
     * @memberof ContactPageResourceBrandCenter
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPageResourceBrandCenter
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPageResourceBrandCenter
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPageResourceBrandCenter
     */
    subtitle: string | null;
}
/**
 * 
 * @export
 * @interface ContactPageResourceHotline
 */
export interface ContactPageResourceHotline {
    /**
     * 
     * @type {string}
     * @memberof ContactPageResourceHotline
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPageResourceHotline
     */
    phone: string;
}
/**
 * 
 * @export
 * @interface DesignListResource
 */
export interface DesignListResource {
    /**
     * 
     * @type {Array<DesignResource>}
     * @memberof DesignListResource
     */
    designs: Array<DesignResource>;
}
/**
 * 
 * @export
 * @interface DesignPageResource
 */
export interface DesignPageResource {
    /**
     * 
     * @type {DesignPageResourceAddressBlock}
     * @memberof DesignPageResource
     */
    address_block: DesignPageResourceAddressBlock;
}
/**
 * 
 * @export
 * @interface DesignPageResourceAddressBlock
 */
export interface DesignPageResourceAddressBlock {
    /**
     * 
     * @type {string}
     * @memberof DesignPageResourceAddressBlock
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DesignPageResourceAddressBlock
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof DesignPageResourceAddressBlock
     */
    video: string;
}
/**
 * 
 * @export
 * @interface DesignResource
 */
export interface DesignResource {
    /**
     * 
     * @type {string}
     * @memberof DesignResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DesignResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof DesignResource
     */
    image: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DesignResource
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DesignResource
     */
    url: string;
}
/**
 * Entity not found
 * @export
 * @interface EntityNotFoundError
 */
export interface EntityNotFoundError {
    /**
     * Error body
     * @type {object}
     * @memberof EntityNotFoundError
     */
    data?: object;
    /**
     * Short error description
     * @type {string}
     * @memberof EntityNotFoundError
     */
    message?: string;
}
/**
 * Feedback
 * @export
 * @interface FeedbackResource
 */
export interface FeedbackResource {
    /**
     * 
     * @type {string}
     * @memberof FeedbackResource
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackResource
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackResource
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedbackResource
     */
    message: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedbackResource
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedbackResource
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedbackResource
     */
    form: FeedbackResourceFormEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FeedbackResourceFormEnum {
    Contacts = 'contacts',
    ServiceCenter = 'service_center',
    Favorites = 'favorites'
}

/**
 * 
 * @export
 * @interface GetProductFilterResponse
 */
export interface GetProductFilterResponse {
    /**
     * Colors for the filter
     * @type {Array<GetProductFilterResponseColors>}
     * @memberof GetProductFilterResponse
     */
    colors: Array<GetProductFilterResponseColors>;
    /**
     * Collections for filter
     * @type {Array<GetProductFilterResponseCollections>}
     * @memberof GetProductFilterResponse
     */
    collections: Array<GetProductFilterResponseCollections>;
    /**
     * Categories for filter
     * @type {Array<GetProductFilterResponseCategories>}
     * @memberof GetProductFilterResponse
     */
    categories: Array<GetProductFilterResponseCategories>;
    /**
     * Brands for filter
     * @type {Array<GetProductFilterResponseBrands>}
     * @memberof GetProductFilterResponse
     */
    brands: Array<GetProductFilterResponseBrands>;
    /**
     * Number of products with a given filter
     * @type {number}
     * @memberof GetProductFilterResponse
     */
    products_count: number;
}
/**
 * 
 * @export
 * @interface GetProductFilterResponseBrands
 */
export interface GetProductFilterResponseBrands {
    /**
     * 
     * @type {BrandFilterResource}
     * @memberof GetProductFilterResponseBrands
     */
    brand: BrandFilterResource;
}
/**
 * 
 * @export
 * @interface GetProductFilterResponseCategories
 */
export interface GetProductFilterResponseCategories {
    /**
     * 
     * @type {CategoryFilterResource}
     * @memberof GetProductFilterResponseCategories
     */
    category: CategoryFilterResource;
}
/**
 * 
 * @export
 * @interface GetProductFilterResponseCollections
 */
export interface GetProductFilterResponseCollections {
    /**
     * 
     * @type {CollectionFilterResource}
     * @memberof GetProductFilterResponseCollections
     */
    collection: CollectionFilterResource;
}
/**
 * 
 * @export
 * @interface GetProductFilterResponseColors
 */
export interface GetProductFilterResponseColors {
    /**
     * 
     * @type {ColorFilterResource}
     * @memberof GetProductFilterResponseColors
     */
    color: ColorFilterResource;
}
/**
 * 
 * @export
 * @interface HomePageResource
 */
export interface HomePageResource {
    /**
     * 
     * @type {HomePageResourceData}
     * @memberof HomePageResource
     */
    data: HomePageResourceData;
}
/**
 * 
 * @export
 * @interface HomePageResourceData
 */
export interface HomePageResourceData {
    /**
     * 
     * @type {Array<AdminHomePageSliderResource>}
     * @memberof HomePageResourceData
     */
    slider: Array<AdminHomePageSliderResource>;
    /**
     * 
     * @type {Array<AdminHomePageBannerResource>}
     * @memberof HomePageResourceData
     */
    banner: Array<AdminHomePageBannerResource>;
    /**
     * 
     * @type {Array<AdminHomePageBlockResource>}
     * @memberof HomePageResourceData
     */
    block: Array<AdminHomePageBlockResource>;
}
/**
 * 
 * @export
 * @interface ImageBlock
 */
export interface ImageBlock {
    /**
     * 
     * @type {ConstructorEnum}
     * @memberof ImageBlock
     */
    type: ConstructorEnum;
    /**
     * 
     * @type {string}
     * @memberof ImageBlock
     */
    image: string;
    /**
     * 
     * @type {string}
     * @memberof ImageBlock
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ImageBlock
     */
    mobile_image: string;
}
/**
 * 
 * @export
 * @interface InstructionResource
 */
export interface InstructionResource {
    /**
     * 
     * @type {string}
     * @memberof InstructionResource
     */
    product_title: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructionResource
     */
    product_article: string;
    /**
     * 
     * @type {string}
     * @memberof InstructionResource
     */
    download_url: string | null;
}
/**
 * 
 * @export
 * @interface InstructionSearchResponse
 */
export interface InstructionSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof InstructionSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof InstructionSearchResponse
     */
    count: number;
    /**
     * 
     * @type {Array<InstructionResource>}
     * @memberof InstructionSearchResponse
     */
    instructions: Array<InstructionResource>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LanguageCode {
    Da = 'da',
    De = 'de',
    En = 'en',
    Fr = 'fr',
    Ro = 'ro',
    Uk = 'uk',
    Be = 'be',
    Nl = 'nl'
}

/**
 * 
 * @export
 * @interface LegalNoticePageResource
 */
export interface LegalNoticePageResource {
    /**
     * 
     * @type {LegalNoticePageResourceAddressBlock}
     * @memberof LegalNoticePageResource
     */
    address_block: LegalNoticePageResourceAddressBlock;
    /**
     * 
     * @type {LegalNoticePageResourceRegistrationBlock}
     * @memberof LegalNoticePageResource
     */
    registration_block: LegalNoticePageResourceRegistrationBlock;
    /**
     * 
     * @type {LegalNoticePageResourceManagerBlock}
     * @memberof LegalNoticePageResource
     */
    manager_block: LegalNoticePageResourceManagerBlock;
}
/**
 * 
 * @export
 * @interface LegalNoticePageResourceAddressBlock
 */
export interface LegalNoticePageResourceAddressBlock {
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceAddressBlock
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceAddressBlock
     */
    address: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegalNoticePageResourceAddressBlock
     */
    websites: Array<string>;
}
/**
 * 
 * @export
 * @interface LegalNoticePageResourceManagerBlock
 */
export interface LegalNoticePageResourceManagerBlock {
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceManagerBlock
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceManagerBlock
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceManagerBlock
     */
    fax: string;
}
/**
 * 
 * @export
 * @interface LegalNoticePageResourceRegistrationBlock
 */
export interface LegalNoticePageResourceRegistrationBlock {
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceRegistrationBlock
     */
    registration_number: string;
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceRegistrationBlock
     */
    fiscal_code: string;
    /**
     * 
     * @type {string}
     * @memberof LegalNoticePageResourceRegistrationBlock
     */
    ust_id: string;
}
/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    base_price: number | null;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    discount: number | null;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    final_price: number;
}
/**
 * 
 * @export
 * @interface ProductCategoryListResource
 */
export interface ProductCategoryListResource {
    /**
     * 
     * @type {Array<ProductCategoryListResourceCategories>}
     * @memberof ProductCategoryListResource
     */
    categories: Array<ProductCategoryListResourceCategories>;
}
/**
 * 
 * @export
 * @interface ProductCategoryListResourceCategories
 */
export interface ProductCategoryListResourceCategories {
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryListResourceCategories
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryListResourceCategories
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryListResourceCategories
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryListResourceCategories
     */
    description: string | null;
    /**
     * 
     * @type {Array<ProductCategoryResource>}
     * @memberof ProductCategoryListResourceCategories
     */
    categories: Array<ProductCategoryResource>;
}
/**
 * 
 * @export
 * @interface ProductCategoryResource
 */
export interface ProductCategoryResource {
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryResource
     */
    slug: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryResource
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryResource
     */
    image: string | null;
}
/**
 * Product Resource
 * @export
 * @interface ProductDetailResource
 */
export interface ProductDetailResource {
    /**
     * ID
     * @type {number}
     * @memberof ProductDetailResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResource
     */
    guid: string;
    /**
     * Name
     * @type {string}
     * @memberof ProductDetailResource
     */
    title: string;
    /**
     * Article
     * @type {string}
     * @memberof ProductDetailResource
     */
    article: string;
    /**
     * 
     * @type {Price}
     * @memberof ProductDetailResource
     */
    price?: Price;
    /**
     * Media
     * @type {Array<string>}
     * @memberof ProductDetailResource
     */
    gallery: Array<string>;
    /**
     * 
     * @type {ProductDetailResourceCollection}
     * @memberof ProductDetailResource
     */
    collection: ProductDetailResourceCollection | null;
    /**
     * Descriptions
     * @type {string}
     * @memberof ProductDetailResource
     */
    product_detail: string | null;
    /**
     * Characteristics (only public)
     * @type {Array<string>}
     * @memberof ProductDetailResource
     */
    characteristics: Array<string>;
    /**
     * Instruction
     * @type {string}
     * @memberof ProductDetailResource
     */
    instruction: string | null;
    /**
     * Awards
     * @type {Array<Award>}
     * @memberof ProductDetailResource
     */
    awards: Array<Award>;
    /**
     * Similar products
     * @type {Array<ProductResource>}
     * @memberof ProductDetailResource
     */
    similar_products: Array<ProductResource>;
    /**
     * Link to the schema
     * @type {string}
     * @memberof ProductDetailResource
     */
    schema: string | null;
    /**
     * Link to the youtube video
     * @type {string}
     * @memberof ProductDetailResource
     */
    youtube_link: string | null;
    /**
     * Product variation
     * @type {ProductVariationResource}
     * @memberof ProductDetailResource
     */
    product_variation: ProductVariationResource | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailResource
     */
    warranty: number | null;
    /**
     * 
     * @type {ProductDetailResourceCategory}
     * @memberof ProductDetailResource
     */
    category: ProductDetailResourceCategory | null;
    /**
     * 
     * @type {ProductDetailResourceBrand}
     * @memberof ProductDetailResource
     */
    brand: ProductDetailResourceBrand | null;
}
/**
 * 
 * @export
 * @interface ProductDetailResourceBrand
 */
export interface ProductDetailResourceBrand {
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceBrand
     */
    guid: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailResourceBrand
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceBrand
     */
    image: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceBrand
     */
    title: string;
}
/**
 * 
 * @export
 * @interface ProductDetailResourceCategory
 */
export interface ProductDetailResourceCategory {
    /**
     * 
     * @type {number}
     * @memberof ProductDetailResourceCategory
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCategory
     */
    image: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCategory
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCategory
     */
    description: string | null;
    /**
     * 
     * @type {ProductDetailResourceCategoryParent}
     * @memberof ProductDetailResourceCategory
     */
    parent: ProductDetailResourceCategoryParent;
}
/**
 * 
 * @export
 * @interface ProductDetailResourceCategoryParent
 */
export interface ProductDetailResourceCategoryParent {
    /**
     * 
     * @type {number}
     * @memberof ProductDetailResourceCategoryParent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCategoryParent
     */
    image: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCategoryParent
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCategoryParent
     */
    description: string | null;
}
/**
 * collection
 * @export
 * @interface ProductDetailResourceCollection
 */
export interface ProductDetailResourceCollection {
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCollection
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailResourceCollection
     */
    image: string;
}
/**
 * Resource for a list of products with pagination
 * @export
 * @interface ProductListResource
 */
export interface ProductListResource {
    /**
     * 
     * @type {number}
     * @memberof ProductListResource
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ProductListResource
     */
    count: number;
    /**
     * 
     * @type {Array<ProductResource>}
     * @memberof ProductListResource
     */
    products: Array<ProductResource>;
}
/**
 * 
 * @export
 * @interface ProductPageResource
 */
export interface ProductPageResource {
    /**
     * 
     * @type {string}
     * @memberof ProductPageResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProductPageResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductPageResource
     */
    video: string;
}
/**
 * Product resource
 * @export
 * @interface ProductResource
 */
export interface ProductResource {
    /**
     * ID
     * @type {number}
     * @memberof ProductResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductResource
     */
    guid: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResource
     */
    title: string;
    /**
     * Article
     * @type {string}
     * @memberof ProductResource
     */
    article: string;
    /**
     * Barcode
     * @type {string}
     * @memberof ProductResource
     */
    preview_image: string;
    /**
     * 
     * @type {Price}
     * @memberof ProductResource
     */
    price: Price;
    /**
     * 
     * @type {string}
     * @memberof ProductResource
     */
    collection_title: string | null;
    /**
     * Product variation
     * @type {ProductVariationResource}
     * @memberof ProductResource
     */
    product_variation: ProductVariationResource | null;
}
/**
 * Product variation resource
 * @export
 * @interface ProductVariationResource
 */
export interface ProductVariationResource {
    /**
     * Variants (by group)
     * @type {Array<ProductVariationResourceVariants>}
     * @memberof ProductVariationResource
     */
    variants: Array<ProductVariationResourceVariants>;
}
/**
 * 
 * @export
 * @interface ProductVariationResourceVariants
 */
export interface ProductVariationResourceVariants {
    /**
     * Product color group
     * @type {string}
     * @memberof ProductVariationResourceVariants
     */
    group: string;
    /**
     * 
     * @type {Array<VariantResource>}
     * @memberof ProductVariationResourceVariants
     */
    variants: Array<VariantResource>;
}
/**
 * 
 * @export
 * @interface ReturnInfoPageResource
 */
export interface ReturnInfoPageResource {
    /**
     * 
     * @type {string}
     * @memberof ReturnInfoPageResource
     */
    description: string | null;
}
/**
 * 
 * @export
 * @interface ServiceCenterPageCategoriesResource
 */
export interface ServiceCenterPageCategoriesResource {
    /**
     * 
     * @type {number}
     * @memberof ServiceCenterPageCategoriesResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageCategoriesResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageCategoriesResource
     */
    icon: string;
}
/**
 * 
 * @export
 * @interface ServiceCenterPageResource
 */
export interface ServiceCenterPageResource {
    /**
     * 
     * @type {ServiceCenterPageResourcePage}
     * @memberof ServiceCenterPageResource
     */
    page: ServiceCenterPageResourcePage;
    /**
     * 
     * @type {ServiceCenterPageResourceBlock}
     * @memberof ServiceCenterPageResource
     */
    block: ServiceCenterPageResourceBlock;
    /**
     * 
     * @type {Array<ServiceCenterPageCategoriesResource>}
     * @memberof ServiceCenterPageResource
     */
    categories: Array<ServiceCenterPageCategoriesResource>;
}
/**
 * 
 * @export
 * @interface ServiceCenterPageResourceBlock
 */
export interface ServiceCenterPageResourceBlock {
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageResourceBlock
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageResourceBlock
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageResourceBlock
     */
    description: string;
    /**
     * 
     * @type {ServiceCenterPageResourceBlockButton}
     * @memberof ServiceCenterPageResourceBlock
     */
    button: ServiceCenterPageResourceBlockButton;
}
/**
 * 
 * @export
 * @interface ServiceCenterPageResourceBlockButton
 */
export interface ServiceCenterPageResourceBlockButton {
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageResourceBlockButton
     */
    title: string;
}
/**
 * 
 * @export
 * @interface ServiceCenterPageResourcePage
 */
export interface ServiceCenterPageResourcePage {
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageResourcePage
     */
    video: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageResourcePage
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceCenterPageResourcePage
     */
    description: string;
}
/**
 * 
 * @export
 * @interface ShopAddressPageResource
 */
export interface ShopAddressPageResource {
    /**
     * 
     * @type {Array<ShopAddressPageResourceShops>}
     * @memberof ShopAddressPageResource
     */
    shops: Array<ShopAddressPageResourceShops>;
}
/**
 * 
 * @export
 * @interface ShopAddressPageResourceShops
 */
export interface ShopAddressPageResourceShops {
    /**
     * 
     * @type {string}
     * @memberof ShopAddressPageResourceShops
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressPageResourceShops
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressPageResourceShops
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressPageResourceShops
     */
    lat?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressPageResourceShops
     */
    lon?: string;
}
/**
 * 
 * @export
 * @interface SmallImageBlock
 */
export interface SmallImageBlock {
    /**
     * 
     * @type {ConstructorEnum}
     * @memberof SmallImageBlock
     */
    type: ConstructorEnum;
    /**
     * 
     * @type {string}
     * @memberof SmallImageBlock
     */
    image: string;
    /**
     * 
     * @type {string}
     * @memberof SmallImageBlock
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof SmallImageBlock
     */
    reverse: boolean;
}
/**
 * 
 * @export
 * @interface SmallVideoBlock
 */
export interface SmallVideoBlock {
    /**
     * 
     * @type {ConstructorEnum}
     * @memberof SmallVideoBlock
     */
    type: ConstructorEnum;
    /**
     * 
     * @type {string}
     * @memberof SmallVideoBlock
     */
    image: string;
    /**
     * 
     * @type {string}
     * @memberof SmallVideoBlock
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof SmallVideoBlock
     */
    reverse: boolean;
}
/**
 * Stock file
 * @export
 * @interface StockFileResource
 */
export interface StockFileResource {
    /**
     * 
     * @type {string}
     * @memberof StockFileResource
     */
    file: string;
}
/**
 * 
 * @export
 * @interface StockFilesResource
 */
export interface StockFilesResource {
    /**
     * 
     * @type {number}
     * @memberof StockFilesResource
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof StockFilesResource
     */
    count: number;
    /**
     * 
     * @type {Array<StockFilesResourceItems>}
     * @memberof StockFilesResource
     */
    items: Array<StockFilesResourceItems>;
}
/**
 * 
 * @export
 * @interface StockFilesResourceItems
 */
export interface StockFilesResourceItems {
    /**
     * 
     * @type {string}
     * @memberof StockFilesResourceItems
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StockFilesResourceItems
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof StockFilesResourceItems
     */
    link: string;
}
/**
 * 
 * @export
 * @interface TechnologyDetailResource
 */
export interface TechnologyDetailResource {
    /**
     * 
     * @type {TechnologyDetailResourceTechnology}
     * @memberof TechnologyDetailResource
     */
    technology: TechnologyDetailResourceTechnology;
    /**
     * 
     * @type {Array<YoutubeBlock | SmallImageBlock | SmallVideoBlock | BigBlock | ImageBlock>}
     * @memberof TechnologyDetailResource
     */
    constructor: Array<YoutubeBlock | SmallImageBlock | SmallVideoBlock | BigBlock | ImageBlock>;
    /**
     * 
     * @type {Array<ProductResource>}
     * @memberof TechnologyDetailResource
     */
    products: Array<ProductResource>;
}
/**
 * 
 * @export
 * @interface TechnologyDetailResourceTechnology
 */
export interface TechnologyDetailResourceTechnology {
    /**
     * 
     * @type {string}
     * @memberof TechnologyDetailResourceTechnology
     */
    type: TechnologyDetailResourceTechnologyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TechnologyDetailResourceTechnology
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyDetailResourceTechnology
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyDetailResourceTechnology
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyDetailResourceTechnology
     */
    media: string;
}

/**
    * @export
    * @enum {string}
    */
export enum TechnologyDetailResourceTechnologyTypeEnum {
    Image = 'image',
    Video = 'video'
}

/**
 * 
 * @export
 * @interface TechnologyListResource
 */
export interface TechnologyListResource {
    /**
     * 
     * @type {Array<TechnologyResource>}
     * @memberof TechnologyListResource
     */
    technologies: Array<TechnologyResource>;
}
/**
 * 
 * @export
 * @interface TechnologyPageResource
 */
export interface TechnologyPageResource {
    /**
     * 
     * @type {string}
     * @memberof TechnologyPageResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyPageResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyPageResource
     */
    background: string;
}
/**
 * 
 * @export
 * @interface TechnologyResource
 */
export interface TechnologyResource {
    /**
     * 
     * @type {number}
     * @memberof TechnologyResource
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TechnologyResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyResource
     */
    image: string;
}
/**
 * Unknown error
 * @export
 * @interface UnknownError
 */
export interface UnknownError {
    /**
     * Error body
     * @type {object}
     * @memberof UnknownError
     */
    data?: object;
    /**
     * Short error description
     * @type {string}
     * @memberof UnknownError
     */
    message?: string;
}
/**
 * Validation error
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * Error body
     * @type {object}
     * @memberof ValidationError
     */
    data?: object;
    /**
     * Short error description
     * @type {string}
     * @memberof ValidationError
     */
    message?: string;
}
/**
 * Variant resource
 * @export
 * @interface VariantResource
 */
export interface VariantResource {
    /**
     * Title
     * @type {string}
     * @memberof VariantResource
     */
    title: string;
    /**
     * Image
     * @type {string}
     * @memberof VariantResource
     */
    image: string;
    /**
     * Hex color code, #ff00da
     * @type {string}
     * @memberof VariantResource
     */
    colour_code?: string | null;
    /**
     * Product
     * @type {ProductResource}
     * @memberof VariantResource
     */
    product: ProductResource | null;
}
/**
 * 
 * @export
 * @interface YoutubeBlock
 */
export interface YoutubeBlock {
    /**
     * 
     * @type {ConstructorEnum}
     * @memberof YoutubeBlock
     */
    type: ConstructorEnum;
    /**
     * 
     * @type {string}
     * @memberof YoutubeBlock
     */
    url: string;
}

/**
 * ArticleApi - axios parameter creator
 * @export
 */
export const ArticleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of years for all articles.
         * @summary Получение всех годов статей
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllYearForArticles: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getAllYearForArticles.');
            }
            const localVarPath = `/api/v1/{lang}/years`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific article by its ID.
         * @summary Получение конкретной статьи по ID
         * @param {LanguageCode} lang Language code
         * @param {number} articleId ID of the article to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticle: async (lang: LanguageCode, articleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getArticle.');
            }
            // verify required parameter 'articleId' is not null or undefined
            if (articleId === null || articleId === undefined) {
                throw new RequiredError('articleId','Required parameter articleId was null or undefined when calling getArticle.');
            }
            const localVarPath = `/api/v1/{lang}/article/{articleId}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all articles.
         * @summary Получение всех статей
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {number} [year] Filter articles by year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleList: async (lang: LanguageCode, pageSize: number, pageNumber: number, year?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getArticleList.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getArticleList.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getArticleList.');
            }
            const localVarPath = `/api/v1/{lang}/articles`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page_number'] = pageNumber;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticleApi - functional programming interface
 * @export
 */
export const ArticleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns a list of years for all articles.
         * @summary Получение всех годов статей
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllYearForArticles(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleYearsResource>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getAllYearForArticles(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves a specific article by its ID.
         * @summary Получение конкретной статьи по ID
         * @param {LanguageCode} lang Language code
         * @param {number} articleId ID of the article to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticle(lang: LanguageCode, articleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Article>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getArticle(lang, articleId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves a list of all articles.
         * @summary Получение всех статей
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {number} [year] Filter articles by year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleList(lang: LanguageCode, pageSize: number, pageNumber: number, year?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArticleListResource>>> {
            const localVarAxiosArgs = await ArticleApiAxiosParamCreator(configuration).getArticleList(lang, pageSize, pageNumber, year, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ArticleApi - factory interface
 * @export
 */
export const ArticleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Returns a list of years for all articles.
         * @summary Получение всех годов статей
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllYearForArticles(lang: LanguageCode, options?: any): AxiosPromise<ArticleYearsResource> {
            return ArticleApiFp(configuration).getAllYearForArticles(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific article by its ID.
         * @summary Получение конкретной статьи по ID
         * @param {LanguageCode} lang Language code
         * @param {number} articleId ID of the article to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticle(lang: LanguageCode, articleId: number, options?: any): AxiosPromise<Article> {
            return ArticleApiFp(configuration).getArticle(lang, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all articles.
         * @summary Получение всех статей
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {number} [year] Filter articles by year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleList(lang: LanguageCode, pageSize: number, pageNumber: number, year?: number, options?: any): AxiosPromise<Array<ArticleListResource>> {
            return ArticleApiFp(configuration).getArticleList(lang, pageSize, pageNumber, year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArticleApi - object-oriented interface
 * @export
 * @class ArticleApi
 * @extends {BaseAPI}
 */
export class ArticleApi extends BaseAPI {
    /**
     * Returns a list of years for all articles.
     * @summary Получение всех годов статей
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getAllYearForArticles(lang: LanguageCode, options?: any) {
        return ArticleApiFp(this.configuration).getAllYearForArticles(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific article by its ID.
     * @summary Получение конкретной статьи по ID
     * @param {LanguageCode} lang Language code
     * @param {number} articleId ID of the article to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getArticle(lang: LanguageCode, articleId: number, options?: any) {
        return ArticleApiFp(this.configuration).getArticle(lang, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all articles.
     * @summary Получение всех статей
     * @param {LanguageCode} lang Language code
     * @param {number} pageSize Pagination size
     * @param {number} pageNumber Pagination number
     * @param {number} [year] Filter articles by year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public getArticleList(lang: LanguageCode, pageSize: number, pageNumber: number, year?: number, options?: any) {
        return ArticleApiFp(this.configuration).getArticleList(lang, pageSize, pageNumber, year, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AwardApi - axios parameter creator
 * @export
 */
export const AwardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a list of all awards.
         * @summary Получение всех наград
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAwardList: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getAwardList.');
            }
            const localVarPath = `/api/v1/{lang}/awards`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AwardApi - functional programming interface
 * @export
 */
export const AwardApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Retrieves a list of all awards.
         * @summary Получение всех наград
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAwardList(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AwardListResource>> {
            const localVarAxiosArgs = await AwardApiAxiosParamCreator(configuration).getAwardList(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AwardApi - factory interface
 * @export
 */
export const AwardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Retrieves a list of all awards.
         * @summary Получение всех наград
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAwardList(lang: LanguageCode, options?: any): AxiosPromise<AwardListResource> {
            return AwardApiFp(configuration).getAwardList(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AwardApi - object-oriented interface
 * @export
 * @class AwardApi
 * @extends {BaseAPI}
 */
export class AwardApi extends BaseAPI {
    /**
     * Retrieves a list of all awards.
     * @summary Получение всех наград
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwardApi
     */
    public getAwardList(lang: LanguageCode, options?: any) {
        return AwardApiFp(this.configuration).getAwardList(lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BannerApi - axios parameter creator
 * @export
 */
export const BannerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение баннера для категории по ID
         * @param {LanguageCode} lang Language code
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LangPageCategoryCategoryIdGet: async (lang: LanguageCode, categoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling apiV1LangPageCategoryCategoryIdGet.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling apiV1LangPageCategoryCategoryIdGet.');
            }
            const localVarPath = `/api/v1/{lang}/page/category/{categoryId}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)))
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannerApi - functional programming interface
 * @export
 */
export const BannerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение баннера для категории по ID
         * @param {LanguageCode} lang Language code
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LangPageCategoryCategoryIdGet(lang: LanguageCode, categoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BannerDetailResource>> {
            const localVarAxiosArgs = await BannerApiAxiosParamCreator(configuration).apiV1LangPageCategoryCategoryIdGet(lang, categoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BannerApi - factory interface
 * @export
 */
export const BannerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Получение баннера для категории по ID
         * @param {LanguageCode} lang Language code
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LangPageCategoryCategoryIdGet(lang: LanguageCode, categoryId: number, options?: any): AxiosPromise<BannerDetailResource> {
            return BannerApiFp(configuration).apiV1LangPageCategoryCategoryIdGet(lang, categoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BannerApi - object-oriented interface
 * @export
 * @class BannerApi
 * @extends {BaseAPI}
 */
export class BannerApi extends BaseAPI {
    /**
     * 
     * @summary Получение баннера для категории по ID
     * @param {LanguageCode} lang Language code
     * @param {number} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerApi
     */
    public apiV1LangPageCategoryCategoryIdGet(lang: LanguageCode, categoryId: number, options?: any) {
        return BannerApiFp(this.configuration).apiV1LangPageCategoryCategoryIdGet(lang, categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CollectionApi - axios parameter creator
 * @export
 */
export const CollectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a specific collection by its ID.
         * @summary Получение конкретной коллекции по ID
         * @param {LanguageCode} lang Language code
         * @param {number} collectionId ID of the collection to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: async (lang: LanguageCode, collectionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getCollection.');
            }
            // verify required parameter 'collectionId' is not null or undefined
            if (collectionId === null || collectionId === undefined) {
                throw new RequiredError('collectionId','Required parameter collectionId was null or undefined when calling getCollection.');
            }
            const localVarPath = `/api/v1/{lang}/collection/{collectionId}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)))
                .replace(`{${"collectionId"}}`, encodeURIComponent(String(collectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all collections.
         * @summary Получение всех коллекций
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionList: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getCollectionList.');
            }
            const localVarPath = `/api/v1/{lang}/collections`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionApi - functional programming interface
 * @export
 */
export const CollectionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Retrieves a specific collection by its ID.
         * @summary Получение конкретной коллекции по ID
         * @param {LanguageCode} lang Language code
         * @param {number} collectionId ID of the collection to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollection(lang: LanguageCode, collectionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Collection>> {
            const localVarAxiosArgs = await CollectionApiAxiosParamCreator(configuration).getCollection(lang, collectionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves a list of all collections.
         * @summary Получение всех коллекций
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionList(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionListResource>> {
            const localVarAxiosArgs = await CollectionApiAxiosParamCreator(configuration).getCollectionList(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CollectionApi - factory interface
 * @export
 */
export const CollectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Retrieves a specific collection by its ID.
         * @summary Получение конкретной коллекции по ID
         * @param {LanguageCode} lang Language code
         * @param {number} collectionId ID of the collection to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection(lang: LanguageCode, collectionId: number, options?: any): AxiosPromise<Collection> {
            return CollectionApiFp(configuration).getCollection(lang, collectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all collections.
         * @summary Получение всех коллекций
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionList(lang: LanguageCode, options?: any): AxiosPromise<CollectionListResource> {
            return CollectionApiFp(configuration).getCollectionList(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CollectionApi - object-oriented interface
 * @export
 * @class CollectionApi
 * @extends {BaseAPI}
 */
export class CollectionApi extends BaseAPI {
    /**
     * Retrieves a specific collection by its ID.
     * @summary Получение конкретной коллекции по ID
     * @param {LanguageCode} lang Language code
     * @param {number} collectionId ID of the collection to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    public getCollection(lang: LanguageCode, collectionId: number, options?: any) {
        return CollectionApiFp(this.configuration).getCollection(lang, collectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all collections.
     * @summary Получение всех коллекций
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    public getCollectionList(lang: LanguageCode, options?: any) {
        return CollectionApiFp(this.configuration).getCollectionList(lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DesignApi - axios parameter creator
 * @export
 */
export const DesignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить все дизайны
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignList: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getDesignList.');
            }
            const localVarPath = `/api/v1/{lang}/design`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesignApi - functional programming interface
 * @export
 */
export const DesignApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить все дизайны
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignList(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignListResource>> {
            const localVarAxiosArgs = await DesignApiAxiosParamCreator(configuration).getDesignList(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DesignApi - factory interface
 * @export
 */
export const DesignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Получить все дизайны
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignList(lang: LanguageCode, options?: any): AxiosPromise<DesignListResource> {
            return DesignApiFp(configuration).getDesignList(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DesignApi - object-oriented interface
 * @export
 * @class DesignApi
 * @extends {BaseAPI}
 */
export class DesignApi extends BaseAPI {
    /**
     * 
     * @summary Получить все дизайны
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignApi
     */
    public getDesignList(lang: LanguageCode, options?: any) {
        return DesignApiFp(this.configuration).getDesignList(lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExportApi - axios parameter creator
 * @export
 */
export const ExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Provides a CSV file for download.
         * @summary Экспорт отчета в CSV
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportCsv: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getExportCsv.');
            }
            const localVarPath = `/api/v1/{lang}/export/csv`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides an Excel file for download.
         * @summary Экспорт отчета в Excel
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportXls: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getExportXls.');
            }
            const localVarPath = `/api/v1/{lang}/export/xls`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportApi - functional programming interface
 * @export
 */
export const ExportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Provides a CSV file for download.
         * @summary Экспорт отчета в CSV
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportCsv(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ExportApiAxiosParamCreator(configuration).getExportCsv(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Provides an Excel file for download.
         * @summary Экспорт отчета в Excel
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportXls(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await ExportApiAxiosParamCreator(configuration).getExportXls(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExportApi - factory interface
 * @export
 */
export const ExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Provides a CSV file for download.
         * @summary Экспорт отчета в CSV
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportCsv(lang: LanguageCode, options?: any): AxiosPromise<any> {
            return ExportApiFp(configuration).getExportCsv(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides an Excel file for download.
         * @summary Экспорт отчета в Excel
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportXls(lang: LanguageCode, options?: any): AxiosPromise<any> {
            return ExportApiFp(configuration).getExportXls(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportApi - object-oriented interface
 * @export
 * @class ExportApi
 * @extends {BaseAPI}
 */
export class ExportApi extends BaseAPI {
    /**
     * Provides a CSV file for download.
     * @summary Экспорт отчета в CSV
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public getExportCsv(lang: LanguageCode, options?: any) {
        return ExportApiFp(this.configuration).getExportCsv(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provides an Excel file for download.
     * @summary Экспорт отчета в Excel
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public getExportXls(lang: LanguageCode, options?: any) {
        return ExportApiFp(this.configuration).getExportXls(lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FavoriteApi - axios parameter creator
 * @export
 */
export const FavoriteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the list of favorite products.
         * @summary Получение любимых продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {Array<string>} productIds product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteList: async (lang: LanguageCode, pageSize: number, pageNumber: number, productIds: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getFavoriteList.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getFavoriteList.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getFavoriteList.');
            }
            // verify required parameter 'productIds' is not null or undefined
            if (productIds === null || productIds === undefined) {
                throw new RequiredError('productIds','Required parameter productIds was null or undefined when calling getFavoriteList.');
            }
            const localVarPath = `/api/v1/{lang}/favorites`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page_number'] = pageNumber;
            }

            if (productIds) {
                localVarQueryParameter['product_ids'] = productIds;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoriteApi - functional programming interface
 * @export
 */
export const FavoriteApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Retrieves the list of favorite products.
         * @summary Получение любимых продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {Array<string>} productIds product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoriteList(lang: LanguageCode, pageSize: number, pageNumber: number, productIds: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListResource>> {
            const localVarAxiosArgs = await FavoriteApiAxiosParamCreator(configuration).getFavoriteList(lang, pageSize, pageNumber, productIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FavoriteApi - factory interface
 * @export
 */
export const FavoriteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Retrieves the list of favorite products.
         * @summary Получение любимых продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {Array<string>} productIds product ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteList(lang: LanguageCode, pageSize: number, pageNumber: number, productIds: Array<string>, options?: any): AxiosPromise<ProductListResource> {
            return FavoriteApiFp(configuration).getFavoriteList(lang, pageSize, pageNumber, productIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FavoriteApi - object-oriented interface
 * @export
 * @class FavoriteApi
 * @extends {BaseAPI}
 */
export class FavoriteApi extends BaseAPI {
    /**
     * Retrieves the list of favorite products.
     * @summary Получение любимых продуктов
     * @param {LanguageCode} lang Language code
     * @param {number} pageSize Pagination size
     * @param {number} pageNumber Pagination number
     * @param {Array<string>} productIds product ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    public getFavoriteList(lang: LanguageCode, pageSize: number, pageNumber: number, productIds: Array<string>, options?: any) {
        return FavoriteApiFp(this.configuration).getFavoriteList(lang, pageSize, pageNumber, productIds, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeedbackApi - axios parameter creator
 * @export
 */
export const FeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Форма обратной связи
         * @param {LanguageCode} lang Language code
         * @param {FeedbackResource} [feedbackResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeedback: async (lang: LanguageCode, feedbackResource?: FeedbackResource, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling postFeedback.');
            }
            const localVarPath = `/api/v1/{lang}/feedback`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof feedbackResource !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(feedbackResource !== undefined ? feedbackResource : {}) : (feedbackResource || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedbackApi - functional programming interface
 * @export
 */
export const FeedbackApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Форма обратной связи
         * @param {LanguageCode} lang Language code
         * @param {FeedbackResource} [feedbackResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFeedback(lang: LanguageCode, feedbackResource?: FeedbackResource, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FeedbackApiAxiosParamCreator(configuration).postFeedback(lang, feedbackResource, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FeedbackApi - factory interface
 * @export
 */
export const FeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Форма обратной связи
         * @param {LanguageCode} lang Language code
         * @param {FeedbackResource} [feedbackResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeedback(lang: LanguageCode, feedbackResource?: FeedbackResource, options?: any): AxiosPromise<void> {
            return FeedbackApiFp(configuration).postFeedback(lang, feedbackResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
export class FeedbackApi extends BaseAPI {
    /**
     * 
     * @summary Форма обратной связи
     * @param {LanguageCode} lang Language code
     * @param {FeedbackResource} [feedbackResource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public postFeedback(lang: LanguageCode, feedbackResource?: FeedbackResource, options?: any) {
        return FeedbackApiFp(this.configuration).postFeedback(lang, feedbackResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PageApi - axios parameter creator
 * @export
 */
export const PageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Страница - О нас
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAboutUs: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageAboutUs.');
            }
            const localVarPath = `/api/v1/{lang}/page/about-us`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Страница контактов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageContact: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageContact.');
            }
            const localVarPath = `/api/v1/{lang}/page/contact`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Страница дизайна
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageDesign: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageDesign.');
            }
            const localVarPath = `/api/v1/{lang}/page/design`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Слайдер домашней страницы
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageHome: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageHome.');
            }
            const localVarPath = `/api/v1/{lang}/page/home`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Legal notice page
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageLegalNotice: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageLegalNotice.');
            }
            const localVarPath = `/api/v1/{lang}/page/legal-notice`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product category page data
         * @summary Данные страницы категории продукта
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageProductCategory: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageProductCategory.');
            }
            const localVarPath = `/api/v1/{lang}/page/category`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product collection page data
         * @summary Данные страницы коллекции продуктов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageProductCollection: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageProductCollection.');
            }
            const localVarPath = `/api/v1/{lang}/page/collection`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Страница с информацией о возврате
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageReturnInfo: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageReturnInfo.');
            }
            const localVarPath = `/api/v1/{lang}/page/return-info`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Страница сервисного центра
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageServiceCenter: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageServiceCenter.');
            }
            const localVarPath = `/api/v1/{lang}/page/service-center`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Страница адресов магазинов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageShopAddress: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageShopAddress.');
            }
            const localVarPath = `/api/v1/{lang}/page/shop-address`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Страница технологий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageTechnology: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getPageTechnology.');
            }
            const localVarPath = `/api/v1/{lang}/page/technology`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageApi - functional programming interface
 * @export
 */
export const PageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Страница - О нас
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageAboutUs(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AboutUsPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageAboutUs(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Страница контактов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageContact(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageContact(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Страница дизайна
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageDesign(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageDesign(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Слайдер домашней страницы
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageHome(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomePageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageHome(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Legal notice page
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageLegalNotice(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalNoticePageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageLegalNotice(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get product category page data
         * @summary Данные страницы категории продукта
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageProductCategory(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageProductCategory(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get product collection page data
         * @summary Данные страницы коллекции продуктов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageProductCollection(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageProductCollection(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Страница с информацией о возврате
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageReturnInfo(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnInfoPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageReturnInfo(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Страница сервисного центра
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageServiceCenter(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceCenterPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageServiceCenter(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Страница адресов магазинов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageShopAddress(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopAddressPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageShopAddress(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Страница технологий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageTechnology(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechnologyPageResource>> {
            const localVarAxiosArgs = await PageApiAxiosParamCreator(configuration).getPageTechnology(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PageApi - factory interface
 * @export
 */
export const PageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Страница - О нас
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageAboutUs(lang: LanguageCode, options?: any): AxiosPromise<AboutUsPageResource> {
            return PageApiFp(configuration).getPageAboutUs(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Страница контактов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageContact(lang: LanguageCode, options?: any): AxiosPromise<ContactPageResource> {
            return PageApiFp(configuration).getPageContact(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Страница дизайна
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageDesign(lang: LanguageCode, options?: any): AxiosPromise<DesignPageResource> {
            return PageApiFp(configuration).getPageDesign(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Слайдер домашней страницы
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageHome(lang: LanguageCode, options?: any): AxiosPromise<HomePageResource> {
            return PageApiFp(configuration).getPageHome(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Legal notice page
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageLegalNotice(lang: LanguageCode, options?: any): AxiosPromise<LegalNoticePageResource> {
            return PageApiFp(configuration).getPageLegalNotice(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get product category page data
         * @summary Данные страницы категории продукта
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageProductCategory(lang: LanguageCode, options?: any): AxiosPromise<ProductPageResource> {
            return PageApiFp(configuration).getPageProductCategory(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get product collection page data
         * @summary Данные страницы коллекции продуктов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageProductCollection(lang: LanguageCode, options?: any): AxiosPromise<CollectionPageResource> {
            return PageApiFp(configuration).getPageProductCollection(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Страница с информацией о возврате
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageReturnInfo(lang: LanguageCode, options?: any): AxiosPromise<ReturnInfoPageResource> {
            return PageApiFp(configuration).getPageReturnInfo(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Страница сервисного центра
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageServiceCenter(lang: LanguageCode, options?: any): AxiosPromise<ServiceCenterPageResource> {
            return PageApiFp(configuration).getPageServiceCenter(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Страница адресов магазинов
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageShopAddress(lang: LanguageCode, options?: any): AxiosPromise<ShopAddressPageResource> {
            return PageApiFp(configuration).getPageShopAddress(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Страница технологий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageTechnology(lang: LanguageCode, options?: any): AxiosPromise<TechnologyPageResource> {
            return PageApiFp(configuration).getPageTechnology(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PageApi - object-oriented interface
 * @export
 * @class PageApi
 * @extends {BaseAPI}
 */
export class PageApi extends BaseAPI {
    /**
     * 
     * @summary Страница - О нас
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageAboutUs(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageAboutUs(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Страница контактов
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageContact(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageContact(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Страница дизайна
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageDesign(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageDesign(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Слайдер домашней страницы
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageHome(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageHome(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Legal notice page
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageLegalNotice(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageLegalNotice(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product category page data
     * @summary Данные страницы категории продукта
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageProductCategory(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageProductCategory(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product collection page data
     * @summary Данные страницы коллекции продуктов
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageProductCollection(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageProductCollection(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Страница с информацией о возврате
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageReturnInfo(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageReturnInfo(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Страница сервисного центра
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageServiceCenter(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageServiceCenter(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Страница адресов магазинов
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageShopAddress(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageShopAddress(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Страница технологий
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPageTechnology(lang: LanguageCode, options?: any) {
        return PageApiFp(this.configuration).getPageTechnology(lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get product by guid
         * @summary Получение продукта по guid
         * @param {LanguageCode} lang Language code
         * @param {string} guid GUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (lang: LanguageCode, guid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getProduct.');
            }
            // verify required parameter 'guid' is not null or undefined
            if (guid === null || guid === undefined) {
                throw new RequiredError('guid','Required parameter guid was null or undefined when calling getProduct.');
            }
            const localVarPath = `/api/v1/{lang}/product/{guid}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)))
                .replace(`{${"guid"}}`, encodeURIComponent(String(guid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get products by category
         * @summary Получение всех категорий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategory: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getProductCategory.');
            }
            const localVarPath = `/api/v1/{lang}/categories`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Фильтр по продуктам
         * @param {LanguageCode} lang Language code
         * @param {string} [brandSlug] Brand slug
         * @param {string} [categoryId] Category id
         * @param {Array<string>} [collectionIds] Collection filter slugs
         * @param {Array<string>} [categoryIds] Category filter ids
         * @param {Array<string>} [colors] Selected colors for filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFilter: async (lang: LanguageCode, brandSlug?: string, categoryId?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getProductFilter.');
            }
            const localVarPath = `/api/v1/{lang}/product/filter`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (brandSlug !== undefined) {
                localVarQueryParameter['brand_slug'] = brandSlug;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }

            if (collectionIds) {
                localVarQueryParameter['collection_ids'] = collectionIds;
            }

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (colors) {
                localVarQueryParameter['colors'] = colors;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение всех продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} [categoryId] category id
         * @param {string} [brandSlug] Brand slug
         * @param {Array<string>} [collectionIds] collection filters ids
         * @param {Array<string>} [categoryIds] Category filter ids
         * @param {Array<string>} [colors] Selected colors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductList: async (lang: LanguageCode, pageSize: number, pageNumber: number, categoryId?: string, brandSlug?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getProductList.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getProductList.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getProductList.');
            }
            const localVarPath = `/api/v1/{lang}/products`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page_number'] = pageNumber;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }

            if (brandSlug !== undefined) {
                localVarQueryParameter['brand_slug'] = brandSlug;
            }

            if (collectionIds) {
                localVarQueryParameter['collection_ids'] = collectionIds;
            }

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }

            if (colors) {
                localVarQueryParameter['colors'] = colors;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get product by guid
         * @summary Получение продукта по guid
         * @param {LanguageCode} lang Language code
         * @param {string} guid GUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(lang: LanguageCode, guid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailResource>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProduct(lang, guid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get products by category
         * @summary Получение всех категорий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCategory(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCategoryListResource>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductCategory(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Фильтр по продуктам
         * @param {LanguageCode} lang Language code
         * @param {string} [brandSlug] Brand slug
         * @param {string} [categoryId] Category id
         * @param {Array<string>} [collectionIds] Collection filter slugs
         * @param {Array<string>} [categoryIds] Category filter ids
         * @param {Array<string>} [colors] Selected colors for filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductFilter(lang: LanguageCode, brandSlug?: string, categoryId?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductFilterResponse>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductFilter(lang, brandSlug, categoryId, collectionIds, categoryIds, colors, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Получение всех продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} [categoryId] category id
         * @param {string} [brandSlug] Brand slug
         * @param {Array<string>} [collectionIds] collection filters ids
         * @param {Array<string>} [categoryIds] Category filter ids
         * @param {Array<string>} [colors] Selected colors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductList(lang: LanguageCode, pageSize: number, pageNumber: number, categoryId?: string, brandSlug?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListResource>> {
            const localVarAxiosArgs = await ProductsApiAxiosParamCreator(configuration).getProductList(lang, pageSize, pageNumber, categoryId, brandSlug, collectionIds, categoryIds, colors, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get product by guid
         * @summary Получение продукта по guid
         * @param {LanguageCode} lang Language code
         * @param {string} guid GUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(lang: LanguageCode, guid: string, options?: any): AxiosPromise<ProductDetailResource> {
            return ProductsApiFp(configuration).getProduct(lang, guid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get products by category
         * @summary Получение всех категорий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategory(lang: LanguageCode, options?: any): AxiosPromise<ProductCategoryListResource> {
            return ProductsApiFp(configuration).getProductCategory(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Фильтр по продуктам
         * @param {LanguageCode} lang Language code
         * @param {string} [brandSlug] Brand slug
         * @param {string} [categoryId] Category id
         * @param {Array<string>} [collectionIds] Collection filter slugs
         * @param {Array<string>} [categoryIds] Category filter ids
         * @param {Array<string>} [colors] Selected colors for filtering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductFilter(lang: LanguageCode, brandSlug?: string, categoryId?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options?: any): AxiosPromise<GetProductFilterResponse> {
            return ProductsApiFp(configuration).getProductFilter(lang, brandSlug, categoryId, collectionIds, categoryIds, colors, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение всех продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} [categoryId] category id
         * @param {string} [brandSlug] Brand slug
         * @param {Array<string>} [collectionIds] collection filters ids
         * @param {Array<string>} [categoryIds] Category filter ids
         * @param {Array<string>} [colors] Selected colors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductList(lang: LanguageCode, pageSize: number, pageNumber: number, categoryId?: string, brandSlug?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options?: any): AxiosPromise<ProductListResource> {
            return ProductsApiFp(configuration).getProductList(lang, pageSize, pageNumber, categoryId, brandSlug, collectionIds, categoryIds, colors, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * Get product by guid
     * @summary Получение продукта по guid
     * @param {LanguageCode} lang Language code
     * @param {string} guid GUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProduct(lang: LanguageCode, guid: string, options?: any) {
        return ProductsApiFp(this.configuration).getProduct(lang, guid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get products by category
     * @summary Получение всех категорий
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductCategory(lang: LanguageCode, options?: any) {
        return ProductsApiFp(this.configuration).getProductCategory(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Фильтр по продуктам
     * @param {LanguageCode} lang Language code
     * @param {string} [brandSlug] Brand slug
     * @param {string} [categoryId] Category id
     * @param {Array<string>} [collectionIds] Collection filter slugs
     * @param {Array<string>} [categoryIds] Category filter ids
     * @param {Array<string>} [colors] Selected colors for filtering
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductFilter(lang: LanguageCode, brandSlug?: string, categoryId?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options?: any) {
        return ProductsApiFp(this.configuration).getProductFilter(lang, brandSlug, categoryId, collectionIds, categoryIds, colors, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение всех продуктов
     * @param {LanguageCode} lang Language code
     * @param {number} pageSize Pagination size
     * @param {number} pageNumber Pagination number
     * @param {string} [categoryId] category id
     * @param {string} [brandSlug] Brand slug
     * @param {Array<string>} [collectionIds] collection filters ids
     * @param {Array<string>} [categoryIds] Category filter ids
     * @param {Array<string>} [colors] Selected colors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductList(lang: LanguageCode, pageSize: number, pageNumber: number, categoryId?: string, brandSlug?: string, collectionIds?: Array<string>, categoryIds?: Array<string>, colors?: Array<string>, options?: any) {
        return ProductsApiFp(this.configuration).getProductList(lang, pageSize, pageNumber, categoryId, brandSlug, collectionIds, categoryIds, colors, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search for product instructions based on product article
         * @summary Поиск инструкций
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} [q] Search term (product article)
         * @param {string} [categoryId] Search term (product categoryId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchInstruction: async (lang: LanguageCode, pageSize: number, pageNumber: number, q?: string, categoryId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getSearchInstruction.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getSearchInstruction.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getSearchInstruction.');
            }
            const localVarPath = `/api/v1/{lang}/search/instructions`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page_number'] = pageNumber;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for products based on a search term
         * @summary Поиск продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} q Search temp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchProduct: async (lang: LanguageCode, pageSize: number, pageNumber: number, q: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getSearchProduct.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getSearchProduct.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getSearchProduct.');
            }
            // verify required parameter 'q' is not null or undefined
            if (q === null || q === undefined) {
                throw new RequiredError('q','Required parameter q was null or undefined when calling getSearchProduct.');
            }
            const localVarPath = `/api/v1/{lang}/search/products`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page_number'] = pageNumber;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Search for product instructions based on product article
         * @summary Поиск инструкций
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} [q] Search term (product article)
         * @param {string} [categoryId] Search term (product categoryId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchInstruction(lang: LanguageCode, pageSize: number, pageNumber: number, q?: string, categoryId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionSearchResponse>> {
            const localVarAxiosArgs = await SearchApiAxiosParamCreator(configuration).getSearchInstruction(lang, pageSize, pageNumber, q, categoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search for products based on a search term
         * @summary Поиск продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} q Search temp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchProduct(lang: LanguageCode, pageSize: number, pageNumber: number, q: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductListResource>> {
            const localVarAxiosArgs = await SearchApiAxiosParamCreator(configuration).getSearchProduct(lang, pageSize, pageNumber, q, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Search for product instructions based on product article
         * @summary Поиск инструкций
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} [q] Search term (product article)
         * @param {string} [categoryId] Search term (product categoryId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchInstruction(lang: LanguageCode, pageSize: number, pageNumber: number, q?: string, categoryId?: string, options?: any): AxiosPromise<InstructionSearchResponse> {
            return SearchApiFp(configuration).getSearchInstruction(lang, pageSize, pageNumber, q, categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for products based on a search term
         * @summary Поиск продуктов
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {string} q Search temp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchProduct(lang: LanguageCode, pageSize: number, pageNumber: number, q: string, options?: any): AxiosPromise<ProductListResource> {
            return SearchApiFp(configuration).getSearchProduct(lang, pageSize, pageNumber, q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     * Search for product instructions based on product article
     * @summary Поиск инструкций
     * @param {LanguageCode} lang Language code
     * @param {number} pageSize Pagination size
     * @param {number} pageNumber Pagination number
     * @param {string} [q] Search term (product article)
     * @param {string} [categoryId] Search term (product categoryId)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public getSearchInstruction(lang: LanguageCode, pageSize: number, pageNumber: number, q?: string, categoryId?: string, options?: any) {
        return SearchApiFp(this.configuration).getSearchInstruction(lang, pageSize, pageNumber, q, categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for products based on a search term
     * @summary Поиск продуктов
     * @param {LanguageCode} lang Language code
     * @param {number} pageSize Pagination size
     * @param {number} pageNumber Pagination number
     * @param {string} q Search temp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public getSearchProduct(lang: LanguageCode, pageSize: number, pageNumber: number, q: string, options?: any) {
        return SearchApiFp(this.configuration).getSearchProduct(lang, pageSize, pageNumber, q, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockFileApi - axios parameter creator
 * @export
 */
export const StockFileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Загрузка документа по остаткам
         * @param {LanguageCode} lang Language code
         * @param {StockFileResource} [stockFileResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LangStockCsvFilePost: async (lang: LanguageCode, stockFileResource?: StockFileResource, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling apiV1LangStockCsvFilePost.');
            }
            const localVarPath = `/api/v1/{lang}/stock/csv/file`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof stockFileResource !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(stockFileResource !== undefined ? stockFileResource : {}) : (stockFileResource || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Файлы с остатками
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LangStockCsvFilesGet: async (lang: LanguageCode, pageSize: number, pageNumber: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling apiV1LangStockCsvFilesGet.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling apiV1LangStockCsvFilesGet.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling apiV1LangStockCsvFilesGet.');
            }
            const localVarPath = `/api/v1/{lang}/stock/csv/files`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page_number'] = pageNumber;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockFileApi - functional programming interface
 * @export
 */
export const StockFileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Загрузка документа по остаткам
         * @param {LanguageCode} lang Language code
         * @param {StockFileResource} [stockFileResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LangStockCsvFilePost(lang: LanguageCode, stockFileResource?: StockFileResource, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await StockFileApiAxiosParamCreator(configuration).apiV1LangStockCsvFilePost(lang, stockFileResource, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Файлы с остатками
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1LangStockCsvFilesGet(lang: LanguageCode, pageSize: number, pageNumber: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockFilesResource>> {
            const localVarAxiosArgs = await StockFileApiAxiosParamCreator(configuration).apiV1LangStockCsvFilesGet(lang, pageSize, pageNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StockFileApi - factory interface
 * @export
 */
export const StockFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Загрузка документа по остаткам
         * @param {LanguageCode} lang Language code
         * @param {StockFileResource} [stockFileResource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LangStockCsvFilePost(lang: LanguageCode, stockFileResource?: StockFileResource, options?: any): AxiosPromise<void> {
            return StockFileApiFp(configuration).apiV1LangStockCsvFilePost(lang, stockFileResource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Файлы с остатками
         * @param {LanguageCode} lang Language code
         * @param {number} pageSize Pagination size
         * @param {number} pageNumber Pagination number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1LangStockCsvFilesGet(lang: LanguageCode, pageSize: number, pageNumber: number, options?: any): AxiosPromise<StockFilesResource> {
            return StockFileApiFp(configuration).apiV1LangStockCsvFilesGet(lang, pageSize, pageNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockFileApi - object-oriented interface
 * @export
 * @class StockFileApi
 * @extends {BaseAPI}
 */
export class StockFileApi extends BaseAPI {
    /**
     * 
     * @summary Загрузка документа по остаткам
     * @param {LanguageCode} lang Language code
     * @param {StockFileResource} [stockFileResource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockFileApi
     */
    public apiV1LangStockCsvFilePost(lang: LanguageCode, stockFileResource?: StockFileResource, options?: any) {
        return StockFileApiFp(this.configuration).apiV1LangStockCsvFilePost(lang, stockFileResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Файлы с остатками
     * @param {LanguageCode} lang Language code
     * @param {number} pageSize Pagination size
     * @param {number} pageNumber Pagination number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockFileApi
     */
    public apiV1LangStockCsvFilesGet(lang: LanguageCode, pageSize: number, pageNumber: number, options?: any) {
        return StockFileApiFp(this.configuration).apiV1LangStockCsvFilesGet(lang, pageSize, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TechnologyApi - axios parameter creator
 * @export
 */
export const TechnologyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить технологию по ID
         * @param {LanguageCode} lang Language code
         * @param {number} technologyId ID of the technology to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnology: async (lang: LanguageCode, technologyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getTechnology.');
            }
            // verify required parameter 'technologyId' is not null or undefined
            if (technologyId === null || technologyId === undefined) {
                throw new RequiredError('technologyId','Required parameter technologyId was null or undefined when calling getTechnology.');
            }
            const localVarPath = `/api/v1/{lang}/technology/{technologyId}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)))
                .replace(`{${"technologyId"}}`, encodeURIComponent(String(technologyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение всех технологий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnologyList: async (lang: LanguageCode, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling getTechnologyList.');
            }
            const localVarPath = `/api/v1/{lang}/technologies`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TechnologyApi - functional programming interface
 * @export
 */
export const TechnologyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить технологию по ID
         * @param {LanguageCode} lang Language code
         * @param {number} technologyId ID of the technology to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnology(lang: LanguageCode, technologyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechnologyDetailResource>> {
            const localVarAxiosArgs = await TechnologyApiAxiosParamCreator(configuration).getTechnology(lang, technologyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Получение всех технологий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnologyList(lang: LanguageCode, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechnologyListResource>> {
            const localVarAxiosArgs = await TechnologyApiAxiosParamCreator(configuration).getTechnologyList(lang, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TechnologyApi - factory interface
 * @export
 */
export const TechnologyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Получить технологию по ID
         * @param {LanguageCode} lang Language code
         * @param {number} technologyId ID of the technology to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnology(lang: LanguageCode, technologyId: number, options?: any): AxiosPromise<TechnologyDetailResource> {
            return TechnologyApiFp(configuration).getTechnology(lang, technologyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение всех технологий
         * @param {LanguageCode} lang Language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnologyList(lang: LanguageCode, options?: any): AxiosPromise<TechnologyListResource> {
            return TechnologyApiFp(configuration).getTechnologyList(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TechnologyApi - object-oriented interface
 * @export
 * @class TechnologyApi
 * @extends {BaseAPI}
 */
export class TechnologyApi extends BaseAPI {
    /**
     * 
     * @summary Получить технологию по ID
     * @param {LanguageCode} lang Language code
     * @param {number} technologyId ID of the technology to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnologyApi
     */
    public getTechnology(lang: LanguageCode, technologyId: number, options?: any) {
        return TechnologyApiFp(this.configuration).getTechnology(lang, technologyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение всех технологий
     * @param {LanguageCode} lang Language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnologyApi
     */
    public getTechnologyList(lang: LanguageCode, options?: any) {
        return TechnologyApiFp(this.configuration).getTechnologyList(lang, options).then((request) => request(this.axios, this.basePath));
    }
}


